import { createAction } from '@reduxjs/toolkit'
import { TreeDataNode } from 'antd'
import { ReportSettingType, ReportType, TreeNode, WalletReportTypes } from './types'

export const updateTree = createAction<TreeDataNode[]>('tree/updateTree')

export const updateReport = createAction<ReportType>('tree/updateReport')

export const addTreeNode = createAction<{ nodeId: string; children: TreeNode[] }>('tree/addTreeNode')

export const setWalletReports = createAction<WalletReportTypes>('tree/setWalletReports')
export const setRefReports = createAction<any>('tree/setRefReports')

export const setReportSetting = createAction<ReportSettingType, string>('tree/setReportSetting')
